<template>
  <el-drawer
    :title="params.drawerType === 'edit' ? '编辑日志库' : '创建日志库'"
    :visible.sync="drawerVisible"
    direction="rtl"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    @closed="onDrawerClosed"
  >
    <drawer-wrapper with-footer class="log-drawer form-drawer">
      <el-form
        :model="logForm"
        :rules="logRules"
        ref="logForm"
        label-width="120px"
        :inline-message="true"
        class="log-form rule-form"
        :label-position="params.drawerType === 'edit' ? 'left' : 'top'"
        v-loading="drawerLoading"
      >
        <div v-if="params.drawerType === 'create'" class="form-drawer-alert">
          <div>
            <img class="icon-warning" src="../../../assets/icon/warning.svg" />
          </div>
          <div>日志库创建成功后名称不可更改，请谨慎操作。</div>
        </div>
        <el-form-item class="form-tip-top" label="日志库名称：" prop="name">
          <span class="word-break" v-if="params.drawerType === 'edit'">{{ logForm.name }}</span>
          <el-input v-else type="input" v-model="logForm.name" placeholder="请输入日志库名称">
          </el-input>
        </el-form-item>
        <el-form-item v-if="params.drawerType === 'create'">
          <p class="form-tip">
            日志库名称最多可以输入 50 个字符，并且只能输入字母、数字或下划线
          </p>
        </el-form-item>
        <el-form-item
          class="form-drawer-description form-tip-top"
          label="描述："
          prop="description"
        >
          <el-input
            v-model="logForm.description"
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="日志库描述最多可以输入 100 个字符"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">
          {{ loading ? `${params.submitLabel}中 ...` : params.submitLabel }}
        </el-button>
      </template>
    </drawer-wrapper>
  </el-drawer>
</template>

<script>
import { reqJudgeLog, reqCreateLog, reqUpdateLog, reqShowLog } from '../../../api/log';
import Validator from '../../../utils/Validator';
import DrawerWrapper from '../../../components/DrawerWrapper/Index';

export default {
  name: 'LogCreatorAndEditor',

  components: {
    DrawerWrapper
  },

  data() {
    const validatorName = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isNotStartsWithNumber())
        .register(validator.isStandardStr())
        .register(validator.lenRange(50))
        .validate();
    };

    const validatorDescLength = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.lenRange(100)).validate();
    };

    const checkRepeat = async (rule, value, callback) => {
      try {
        // 如果是新建，检查名称是否重复
        if (this.params.drawerType === 'edit') {
          callback();
          return;
        }

        this.drawerLoading = true;
        const { data } = await reqJudgeLog({
          logName: value,
          projectId: this.params.projectId
        });

        if (data) {
          callback(new Error('日志名称已存在'));
        } else {
          callback();
        }
      } catch {
        this.$message.error('网络连接超时，请稍候重试');
      } finally {
        this.drawerLoading = false;
      }
    };

    return {
      params: {
        drawerType: '',
        logId: null,
        submitLabel: ''
      },
      drawerVisible: false,
      logForm: {
        name: '',
        description: ''
      },
      logRules: {
        name: [
          { required: true, message: '请输入日志库名称', trigger: 'blur' },
          { validator: validatorName, trigger: 'blur' },
          { validator: checkRepeat, trigger: 'blur' }
        ],
        description: { validator: validatorDescLength, trigger: 'blur' }
      },
      loading: false,
      drawerLoading: false
    };
  },

  methods: {
    async open({ drawerType, logId, projectId }) {
      this.params.drawerType = drawerType;
      this.params.logId = logId;
      this.params.projectId = projectId;
      this.params.submitLabel = drawerType === 'edit' ? '保存' : '创建';
      this.drawerVisible = true;

      this.logForm.projectId = this.params.projectId;

      if (drawerType !== 'edit') {
        return;
      }

      try {
        this.drawerLoading = true;
        const { data } = await reqShowLog(logId);

        this.logForm.name = data.name;
        this.logForm.description = data.description;
        this.logForm.id = logId;
      } finally {
        this.drawerLoading = false;
      }
    },
    onCancel() {
      this.drawerVisible = false;
      this.$emit('cancel');
    },
    async onSubmit() {
      try {
        await this.$refs.logForm.validate();
      } catch (e) {
        return;
      }
      try {
        this.loading = true;

        const { data } =
          this.params.drawerType === 'edit'
            ? await reqUpdateLog(this.logForm)
            : await reqCreateLog(this.logForm);

        this.$emit('submit', this.params.drawerType, this.logForm.name, data);
      } finally {
        this.drawerVisible = false;
        this.loading = false;
      }
    },
    onDrawerClosed() {
      this.$refs.logForm.resetFields();

      this.logForm = {
        name: '',
        description: ''
      };
    }
  }
};
</script>
